<template>
    <div v-if="appData.terminatedContract" class="default-message" v-t="'message.error_contract_termination'">
    </div>
    <div v-else class="user-panel">
        <table v-if="appData.actionRequireTenantCount > 0" class="alertfield">
            <tr class="alertrecord"
                v-t="{ path: 'message.info_need_action_to_link_tenant', args: { actionRequireTenantCount: appData.actionRequireTenantCount } }">
            </tr>
        </table>
        <table
            :class="{ 'with-alert': (appData.actionRequireTenantCount > 0), 'no-alert': (appData.actionRequireTenantCount == 0) }"
            cellpadding=0 cellspacing=0>
            <tr class="itemheader">
                <td height="100%" style="width: 250px">
                    <div class="inner-panel">
                        <div class="scrollable">
                            <div class="treetitle" v-t="'message.item_setting'">
                            </div>
                            <el-tree v-if="showTree" class="setting-tree" :props="properties" :load="loadNode" lazy
                                ref="tree" node-key="settingId" default-expanded-keys="{clientRoot}" highlight-current
                                @node-click="handleNodeClick" @node-collapse="handleNodeCollapse"
                                :render-content="renderContent">
                            </el-tree>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="inner-panel">
                        <div class="scrollable">
                            <component
                                v-bind:selectedNode="selectedNode"
                                v-bind:appData="appData"
                                :is="selectedChild"
                                :ref="selectedChild"
                                @setCurrentNode="setCurrentNode"
                                @reloadTree="reloadTree"
                                @reLoadTenantInfo="reLoadTenantInfo"
                                @updateActionRequireTenantCount="updateActionRequireTenantCount"
                                @updateConnectedTenantList="updateConnectedTenantList"
                            ></component>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from "@/components/constants.js";
import InitialUserRightPanel from "@/components/InitialUserRightPanel.vue";
import LinkTenantSettingRoot from "@/components/pc/setting/linktenant/LinkTenantSettingRoot.vue";
import LinkTenantSetting from "@/components/pc/setting/linktenant/LinkTenantSetting.vue"
import SamlSetting from "@/components/pc/setting/saml/SamlSetting.vue";
import PermitIpSetting from "@/components/pc/setting/permitip/PermitIpSetting.vue";
import AiAppSetting from "@/components/pc/setting/ai-app/AiAppSetting.vue";
import AiPromptSetting from "@/components/pc/setting/ai-prompt/AiPromptSetting.vue";
import SttDictionarySetting from "@/components/pc/setting/sttextention/SttDictionarySetting.vue";
import SttP2PEngineSetting from "@/components/pc/setting/sttextention/SttP2PEngineSetting.vue";
import HelpLinkSetting from "@/components/pc/setting/helplink/HelpLinkSetting.vue";
import TwoPhaseMethodSetting from "@/components/pc/setting/twophasemethod/TwoPhaseMethodSetting.vue";
import E2EEncryptionSetting from "@/components/pc/setting/e2eencryption/E2EEncryptionSetting.vue";
import ClientSetting from "@/components/pc/setting/clientsetting/ClientSetting.vue";
import DisableP2PSaveVoiceSetting from "@/components/pc/setting/p2pSaveVoice/DisableP2PSaveVoiceSetting.vue";
import P2PAutoEndTimeSetting from "@/components/pc/setting/p2pSetting/P2PAutoEndTimeSetting.vue";
import DeviceManagementSetting from "@/components/pc/setting/devicemanagement/DeviceManagementSetting.vue";
import AppControlSetting from "@/components/pc/setting/appcontrol/AppControlSetting.vue";
import MapImageOverlaySetting from "@/components/pc/setting/mapImageOverlay/MapImageOverlaySetting.vue";
import BuddyBotAPI from "@/components/pc/setting/buddybotapi/BuddyBotAPI.vue";
import BuddycomCallSetting from "@/components/pc/setting/buddycomCall/BuddycomCallSetting.vue";
import AdvancedSetting from '@/components/pc/setting/advanced/AdvancedSetting.vue';

import {
    FEATURE_C2C_LIMIT,
    FEATURE_JKC_LONG_TALK_GROUP,
    FEATURE_SUMMARY
} from "@/components/feature_toggles/feature_toggle";

// settings for client settings
// ClientSetting.vueがこの値に依存した実装となっている。
const SETTING_CLIENT_MANAGE_ROOT = 1;
const SETTING_CLIENT_MANAGE_NODE = 2;
// settings for tenant
const SETTING_INTER_COMPANY = 3;
const SETTING_INTER_COMPANY_IMPORT = 4;
const SETTING_INTER_COMPANY_EXPORT = 5;
const SETTING_SAML = 6;
const SETTING_PERMIT_IP = 7;
const SETTING_AI_APP = 8;
const SETTING_AI_PROMPT = 9;
const SETTING_STT_EXTENSION_ROOT = 11;
const SETTING_STT_EXTENSION_DICTIONARY = 12;
const SETTING_ASSISTANT_API = 13;
const SETTING_ADVANCED = 14;
// settings for a client
const SETTING_TWO_PHASE_METHOD = 101;
const SETTING_DEVICE_MANAGEMENT = 102;
const SETTING_E2E_ENCRYPTION = 103;
const SETTING_P2P_ROOT = 104;
const SETTING_P2P_DISABLE_SAVE = 105;
const SETTING_P2P_STT_TRANSLATION_ENGINE = 106;
const SETTING_P2P_AUTO_END_TIME = 107;
const SETTING_MAP_IMAGE_OVERLAY = 108;
const SETTING_HELP_LINK = 109;
const SETTING_APP_CONTROL = 110;
const SETTING_BUDDYCOM_CALL = 111;

export default {
    components: {
        InitialUserRightPanel,
        LinkTenantSettingRoot,
        LinkTenantSetting,
        SamlSetting,
        PermitIpSetting,
        AiAppSetting,
        AiPromptSetting,
        SttDictionarySetting,
        SttP2PEngineSetting,
        TwoPhaseMethodSetting,
        E2EEncryptionSetting,
        HelpLinkSetting,
        ClientSetting,
        DisableP2PSaveVoiceSetting,
        P2PAutoEndTimeSetting,
        DeviceManagementSetting,
        AppControlSetting,
        MapImageOverlaySetting,
        BuddycomCallSetting,
        BuddyBotAPI,
        AdvancedSetting
    },

    props: ['appData'],

    data() {
        return {
            showTree: true,
            clientSettingNode: [],
            selectedNode: null,
            loadCompleted: false,
            needToReloadTree: false,
            tenantAppsLoadingPromise: null,
            properties: {
                label: 'label',
                isLeaf: 'isLeaf'
            },
        };
    },

    methods: {
        async ensureTenantAppsLoaded() {
            if (this.appData.apps != null) {
                return;
            }

            if (this.tenantAppsLoadingPromise == null) {
                this.tenantAppsLoadingPromise = server.post('/gettenantapps')
                    .then((res) => {
                        if (res.data.status === constants.STATUS_SUCCESS) {
                            this.$set(this.appData, 'apps', res.data.apps);
                        }
                    })
                    .catch((error) => {
                        commonUtil.putExceptionErrorMessage(this, "ensureTenantAppsLoaded", error);
                    })
                    .finally(() => {
                        this.tenantAppsLoadingPromise = null;
                    });
            }
        },
        async loadNode(node, resolve) {
            var data = [];
            if (node.parent == null) {
                await this.ensureTenantAppsLoaded();

                /* hide server setting.*/
                let settingName = commonUtil.getMessageText(this.$i18n, "item_inter_company_comm");
                let serverSetting = {
                    settingId: "linktenant",
                    settingName: settingName,
                    label: settingName,
                    type: SETTING_INTER_COMPANY,
                    isLeaf: this.appData.isRadioAdminOnlyUser || !FEATURE_C2C_LIMIT
                };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n, "item_saml_setting");
                serverSetting = {
                    settingId: "saml",
                    settingName: settingName,
                    label: settingName,
                    type: SETTING_SAML,
                    isLeaf: true
                };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n, "item_permit_ip_setting");
                serverSetting = {
                    settingId: "permitip",
                    settingName: settingName,
                    label: settingName,
                    type: SETTING_PERMIT_IP,
                    isLeaf: true
                };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n, "item_ai_setting");
                serverSetting = {
                    settingId: "aiappsetting",
                    settingName: settingName,
                    label: settingName,
                    type: SETTING_AI_APP,
                    isLeaf: true
                };
                data.push(serverSetting);

                if (FEATURE_SUMMARY && (this.appData.apps & constants.RESERVED3)) {
                    settingName = commonUtil.getMessageText(this.$i18n, "item_ai_prompt_setting");
                    serverSetting = {
                        settingId: "aipromptsetting",
                        settingName: settingName,
                        label: settingName,
                        type: SETTING_AI_PROMPT,
                        isLeaf: true
                    };
                    data.push(serverSetting);
                }

                settingName = commonUtil.getMessageText(this.$i18n, "item_stt_extension_setting");
                serverSetting = {
                    settingId: "stt_extension_setting",
                    label: settingName,
                    type: SETTING_STT_EXTENSION_ROOT,
                    isLeaf: false,
                };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n, "item_buddy_bot_api_setting");
                serverSetting = {
                    settingId: "buddyBotApi",
                    settingName: settingName,
                    label: settingName,
                    type: SETTING_ASSISTANT_API,
                    isLeaf: true
                };
                data.push(serverSetting);

                if (FEATURE_JKC_LONG_TALK_GROUP) {
                    settingName = commonUtil.getMessageText(this.$i18n, "item_advanced_setting");
                    serverSetting = {
                        settingId: "advancedSetting",
                        label: settingName,
                        type: SETTING_ADVANCED,
                        isLeaf: true
                    };
                    data.push(serverSetting);
                }

                settingName = commonUtil.getMessageText(this.$i18n, "item_two_phase_method_setting");
                serverSetting = {
                    settingId: "twophasemethod",
                    settingName: settingName,
                    label: settingName,
                    type: SETTING_TWO_PHASE_METHOD,
                    isLeaf: true
                };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n, "item_device_management_setting");
                serverSetting = {
                    settingId: "deviceManagementSetting",
                    label: settingName,
                    type: SETTING_DEVICE_MANAGEMENT,
                    isLeaf: true
                };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n, "item_e2e_encryption");
                serverSetting = {
                    settingId: "e2eencryptionsetting",
                    label: settingName,
                    type: SETTING_E2E_ENCRYPTION,
                    isLeaf: true
                };
                data.push(serverSetting);

                if (this.appData.enableMapImageOverlay || this.appData.enableMapImageOverlayTrial) {
                    settingName = commonUtil.getMessageText(this.$i18n, "item_map_image_overlay");
                    serverSetting = {
                        settingId: "title_edit_map_image_overlay_setting",
                        label: settingName,
                        type: SETTING_MAP_IMAGE_OVERLAY,
                        isLeaf: true
                    };
                    data.push(serverSetting);
                }

                settingName = commonUtil.getMessageText(this.$i18n, "item_peer_to_peer_setting");
                serverSetting = {
                    settingId: "peer_to_peer_setting",
                    settingName: settingName,
                    label: settingName,
                    type: SETTING_P2P_ROOT,
                    isLeaf: false
                };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n, "item_help_link_setting");
                serverSetting = {
                    settingId: "helpLinkSetting",
                    label: settingName,
                    type: SETTING_HELP_LINK,
                    isLeaf: true
                };
                data.push(serverSetting);

                // ライセンス付与時のみ表示
                if (this.appData.enableBuddyComCall || this.appData.enableBuddyComCallTrial){
                    settingName = commonUtil.getMessageText(this.$i18n, "item_buddycom_call_setting");
                    serverSetting = {
                        settingId: "buddycomCallSetting",
                        label: settingName,
                        type: SETTING_BUDDYCOM_CALL,
                        isLeaf: true
                    };
                    data.push(serverSetting);
                }

                settingName = commonUtil.getMessageText(this.$i18n, "item_app_control");
                serverSetting = {
                    settingId: "appControl",
                    label: settingName,
                    type: SETTING_APP_CONTROL,
                    isLeaf: true
                };
                data.push(serverSetting);

                settingName = commonUtil.getMessageText(this.$i18n, "item_enforce_client_setting");
                let clientSettingRoot;
                this.clientSettingNode = [];

                let clientSettingsResponse;
                try {
                    clientSettingsResponse = await server.post('/getenforceclientsettinglist')
                } catch (error) {
                    commonUtil.putExceptionErrorMessage(this, "loadNode", error);
                }

                const clientSettings = clientSettingsResponse.data.template;
                switch (clientSettingsResponse.data.status) {
                    case 0:
                        clientSettingRoot = {
                            settingId: "clientRoot",
                            settingName: settingName,
                            label: settingName,
                            type: SETTING_CLIENT_MANAGE_ROOT,
                            isLeaf: clientSettings.length === 0
                        };

                        // 階層へのクライアント設定割り当てがOFFの場合
                        if(!this.appData.clientSettingsForEachNode) {
                            for (let i = 0; i < clientSettings.length; i++) {
                                this.clientSettingNode.push({
                                    settingId: clientSettings[i].templateId,
                                    settingName: clientSettings[i].templateName,
                                    label: clientSettings[i].templateName,
                                    type: SETTING_CLIENT_MANAGE_NODE,
                                    isLeaf: true
                                })
                            }
                            this.clientSettingNode.sort(function (e1, e2) {
                                if (e1.type < e2.type) return -1;
                                else if (e1.type > e2.type) return 1;
                                else {
                                    let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                                    if (comparisonResult < 0) return -1;
                                    else if (comparisonResult > 0) return 1;
                                }
                                return 0;
                            });
                        }

                        break;
                    case -15:           // enforce client setting license not found.
                        clientSettingRoot = {
                            settingId: "clientRoot",
                            settingName: settingName,
                            label: settingName,
                            type: SETTING_CLIENT_MANAGE_ROOT,
                            isLeaf: true
                        };
                        break;
                    default:
                        node.loading = false;
                        node.isLeaf = true;
                        node.data.isLeaf = true;
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "loadNode").replace("{code}", res.data.status));
                        break;
                }
                data.push(clientSettingRoot);

                resolve(data);
                this.loadCompleted = true;
            } else {
                switch (node.data.settingId) {
                    case "linktenant":
                        resolve(commonUtil.getLinkTenantTreeData(this.$i18n));
                        break;
                    case "stt_extension_setting":
                        resolve(
                            [
                                {
                                    label: commonUtil.getMessageText(this.$i18n, "item_stt_extension_setting_dictionary"),
                                    type: SETTING_STT_EXTENSION_DICTIONARY,
                                    isLeaf: true
                                }
                            ]
                        );
                        break;
                    case "clientRoot":
                        resolve(this.clientSettingNode);
                        break;
                    case "peer_to_peer_setting":
                        resolve(
                            [
                                {
                                    label: commonUtil.getMessageText(this.$i18n, "item_save_voice"),
                                    type: SETTING_P2P_DISABLE_SAVE,
                                    isLeaf: true
                                },
                                {
                                    label: commonUtil.getMessageText(this.$i18n, "item_stt_extension_setting_p2p_engine"),
                                    type: SETTING_P2P_STT_TRANSLATION_ENGINE,
                                    isLeaf: true
                                },
                                {
                                    label: commonUtil.getMessageText(this.$i18n, "item_setting_p2p_auto_end_time"),
                                    type: SETTING_P2P_AUTO_END_TIME,
                                    isLeaf: true
                                }
                            ]
                        )
                        break;
                }
            }
        },
        handleNodeClick(data, node, elNode) {
            this.selectedNode = node;
        },
        handleNodeCollapse(data, node, elNode) {
            node.expand();
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = "";
            let height = "20px";

            switch (data.type) {
                case SETTING_INTER_COMPANY:             // server setting
                case SETTING_INTER_COMPANY_IMPORT:
                case SETTING_INTER_COMPANY_EXPORT:
                case SETTING_SAML:
                case SETTING_ASSISTANT_API:
                case SETTING_ADVANCED:
                case SETTING_AI_PROMPT:
                    objectIcon = require("../../../assets/icon_server_setting.svg");
                    break;
                case SETTING_CLIENT_MANAGE_ROOT:        // client setting's root
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break;
                case SETTING_CLIENT_MANAGE_NODE:        // client setting
                    objectIcon = require("../../../assets/square_green.svg");
                    height = "6px";
                    break;
                case SETTING_PERMIT_IP:       // permit_ip_setting
                    objectIcon = require("../../../assets/icon_server_setting.svg");
                    break;
                case SETTING_AI_APP:
                    objectIcon = require("../../../assets/icon_server_setting.svg");
                    break;
                case SETTING_P2P_ROOT:
                case SETTING_P2P_DISABLE_SAVE:
                case SETTING_P2P_STT_TRANSLATION_ENGINE:
                case SETTING_P2P_AUTO_END_TIME:
                    objectIcon = require("../../../assets/icon_client_setting.svg");
                    break;
                case SETTING_TWO_PHASE_METHOD:
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break;
                case SETTING_E2E_ENCRYPTION:
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break;
                case SETTING_MAP_IMAGE_OVERLAY:
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break;
                case SETTING_HELP_LINK:
                case SETTING_DEVICE_MANAGEMENT:
                case SETTING_APP_CONTROL:
                case SETTING_BUDDYCOM_CALL:
                    objectIcon = require("../../../assets/icon_client_setting_group.svg");
                    break
                case SETTING_STT_EXTENSION_ROOT:
                case SETTING_STT_EXTENSION_DICTIONARY:
                    objectIcon = require("../../../assets/icon_server_setting.svg");
                    break;
            }

            return h("span", [h("img", { attrs: { src: objectIcon, height: height, style: "vertical-align: middle" } }), h("span", node.label)]);
        },
        reloadTree() {
            this.showTree = false;
            this.$nextTick(() => {
                this.showTree = true
            })
        },
        setCurrentNode(settingId) {
            this.$refs.tree.setCurrentKey(settingId);
            this.selectedNode = this.$refs.tree.getNode(settingId);
        },
        reLoadTenantInfo() {
            this.$emit('loadTenantInfo');
        },
        updateActionRequireTenantCount(count) {
            this.$emit('updateActionRequireTenantCount', count);
        },
        updateConnectedTenantList() {
            this.$emit("updateConnectedTenantList");
        }
    },
    created: function () {
    },
    mounted: function () {
        this.selectedNode = this.$refs.tree.getNode(0);
    },
    computed: {
        selectedChild: function () {
            if (this.selectedNode != null) {
                switch (this.selectedNode.data.type) {
                    case SETTING_INTER_COMPANY:
                        return "LinkTenantSettingRoot";
                    case SETTING_INTER_COMPANY_IMPORT:
                    case SETTING_INTER_COMPANY_EXPORT:
                        return "LinkTenantSetting";
                    case SETTING_CLIENT_MANAGE_ROOT:
                    case SETTING_CLIENT_MANAGE_NODE:
                        return "ClientSetting";
                    case SETTING_PERMIT_IP:
                        return "PermitIpSetting";
                    case SETTING_SAML:
                        return "SamlSetting";
                    case SETTING_AI_APP:
                        return "AiAppSetting";
                    case SETTING_AI_PROMPT:
                        return "AiPromptSetting";
                    case SETTING_TWO_PHASE_METHOD:
                        return "TwoPhaseMethodSetting";
                    case SETTING_E2E_ENCRYPTION:
                        return "E2EEncryptionSetting";
                    case SETTING_HELP_LINK:
                        return "HelpLinkSetting";
                    case SETTING_STT_EXTENSION_ROOT:
                    case SETTING_STT_EXTENSION_DICTIONARY:
                        return "SttDictionarySetting";
                    case SETTING_P2P_ROOT:
                    case SETTING_P2P_DISABLE_SAVE:
                        return "DisableP2PSaveVoiceSetting";
                    case SETTING_P2P_STT_TRANSLATION_ENGINE:
                        return "SttP2PEngineSetting";
                    case SETTING_P2P_AUTO_END_TIME:
                        return "P2PAutoEndTimeSetting"
                    case SETTING_DEVICE_MANAGEMENT:
                        return "DeviceManagementSetting";
                    case SETTING_APP_CONTROL:
                        return "AppControlSetting";
                    case SETTING_MAP_IMAGE_OVERLAY:
                        return "MapImageOverlaySetting";
                    case SETTING_ASSISTANT_API:
                        return "BuddyBotAPI";
                    case SETTING_BUDDYCOM_CALL:
                        return "BuddycomCallSetting";
                    case SETTING_ADVANCED:
                        return "AdvancedSetting";
                    default:
                        console.warn('no match. got:', this.selectedNode.data.type);
                }
            }
            this.appData.selectedMenu = 'setting';
            return "InitialUserRightPanel";
        },
    },
    watch: {
        '$i18n.locale'() {
            if (this.loadCompleted) {
                this.reloadTree();
            } else {
                // Part of data is not displayed by selected language when selected locale has changed during loading data of tree.
                // check needToReloadTree at loadCompleted , and reloadTree to display all data by selected language.
                this.needToReloadTree = true;
            }
        },
        'loadCompleted'() {
            if (this.loadCompleted) {
                if (this.needToReloadTree) {
                    this.reloadTree();
                    this.needToReloadTree = false;
                }
            }
        },
        '$route'(to, from) {
            if (to.name == "Setting") {
                this.$refs.tree.setCurrentKey(null);
                this.selectedNode = null;
            }
        },
        'appData.tenantAdminUser'() {
            this.reloadTree();
        },
        'appData.clientSettingsForEachNode'() {
            this.reloadTree();
        },
        'appData.apps'() {
            this.reloadTree();
        },
       'appData.enableMapImageOverlay'() {
            this.reloadTree();
        }
    }
}
</script>

<style scoped>
table {
    border-collapse: collapse;
}

table.no-alert {
    height: 100%;
    width: 100%;
    cellpadding: 0;
    cellspacing: 0;
}

table.with-alert {
    height: calc(100% - 53px);
    width: 100%;
    cellpadding: 0;
    cellspacing: 0;
}

.treetitle {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
}

.user-panel {
    height: 100%;
    background-color: #ffffff;
}

.inner-panel {
    position: relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #ffffff;
}

.scrollable {
    overflow: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-top: solid;
    border-color: #eee;
    border-width: 1px;
}

.command-area {
    background-color: #ecf1fa;
    width: 100%;
    display: block;
    text-align: left;
    padding-left: 20px;
    height: 56px;
    vertical-align: bottom;
}

.command-area-left {
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: middle;
    float: left;
}

.command-area-right {
    padding-right: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: right;
    vertical-align: middle;
}

.setting-table {
    padding-top: 20px;
    padding-left: 20px;
    width: 480px;
}

.optionItem {
    width: 500px;
}

.setting-tree.el-tree >>> .el-tree-node {
  min-width: 300px;
}

.setting-tree.el-tree {
    overflow: auto;
}

.setting-tree.el-tree {
    width: 100%;
    height: calc(100vh - 120px);
}
</style>
